const sortByPropertyName = (list, propertyName) => {
  return (
    list && list.sort((a, b) => a[propertyName].localeCompare(b[propertyName]))
  );
};

export default sortByPropertyName;
